import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpService } from './http/http-client.service';
import { EncriptyUtilService } from './encripty-util.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

const API = environment.url_server;

@Injectable()
export class CommonService {

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private encriptyService: EncriptyUtilService
  ) { }

  buscaProdutos() {
    return this.http.get(API + '/enterprise/activeProductList');
  }

  isProdutoMigrado(): Observable<boolean> {
    const productIdEnc = localStorage.getItem('bway-product-id');
    if (!productIdEnc || productIdEnc === 'null') {
      return of(false);
    }
    const productId = this.encriptyService.decriptyBySecretKey(productIdEnc);
    return this.buscaProdutos().pipe(
      map((response: any[]) => {
        const product = response.find(p => p.produtoId === Number(productId));
        return !!(product && product.portalLegadoLiberado === false);
      }),
      catchError(() => of(false))
    );
  }

  isProdutoMigradoPorDescricao(produtoDescricao: string): Observable<boolean> {
    return this.buscaProdutos().pipe(
      map((response: any[]) => {
        const product = response.find(p => p.produtoDescricao === produtoDescricao);
        return !!(product && product.portalLegadoLiberado === false);
      }),
      catchError(() => of(false))
    );
  }

  isAlgumProdutoMigradoPorDescricao(produtosDescricao: string[]): Observable<boolean> {
    return this.buscaProdutos().pipe(
      map((response: any[]) => response.some(product =>
        produtosDescricao.includes(product.produtoDescricao) && product.portalLegadoLiberado === false
      )),
      catchError(() => of(false))
    );
  }

  buscaSaldoGlobal() {
    return this.http.get(API +'/enterprise/balanceLimit');
  }


  isUserAllowed(data: any, successHandle: Function, errorHandle: Function){
    return this.httpService.doGet('/roleAccess/check-user', data, successHandle, errorHandle);
  }

}
